"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const SearchIcon = (props) => {
    return (react_1.default.createElement(core_1.SvgIcon, Object.assign({}, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14.215 14.215" },
            react_1.default.createElement("g", { id: "_12", "data-name": "12", transform: "translate(-4.02 -4.02)" },
                react_1.default.createElement("path", { id: "Path_766", "data-name": "Path 766", d: "M18.094,17.271,14.36,13.537a5.821,5.821,0,1,0-.823.823l3.734,3.734a.584.584,0,0,0,.823-.823ZM6.541,13.146a4.639,4.639,0,1,1,3.3,1.378,4.668,4.668,0,0,1-3.3-1.378Z", transform: "translate(0)" })))));
};
exports.default = SearchIcon;
